import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { all_routes } from "./router/all_routes";
import "bootstrap-daterangepicker/daterangepicker.css";
import Header from "./Header";
import Swal from "sweetalert2";
import { Select } from "antd";
import { ProductContext } from "../context/AppContext";


const ExamReTest = () => {

    const navigate = useNavigate();
  const location = useLocation();

  // Receive params (similar to route.params in React Native)
  const { examId, bookingId } = location.state || {};
  console.log("Exam ID:", examId);
  console.log("Booking ID:", bookingId);

  const { getRegistration } = useContext(ProductContext);
  const Regi_id = Number(getRegistration?.data?.id);
  console.log("Regi_id:", Regi_id);

  const [loading, setLoading] = useState(false);
  const [getExamExamData, setGetExamExamData] = useState(null);
  const [filteredExam, setFilteredExam] = useState([]);
  const [loadingExamId, setLoadingExamId] = useState(null);
  const [formData, setFormData] = useState({ exam_date: null });
  const authtoken = localStorage.getItem("token");

  // ✅ Fetch Exam Schedule Data
  useEffect(() => {
    const fetchExamScheduleData = async () => {
      try {
        const response = await fetch(
          `https://api.mirai.healthcare/api/exam-schedule?exam_id=${examId}`,
          {
            method: "GET",
            headers: {
              "x-auth": `${authtoken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        console.log("Exam Data:", data);
        setGetExamExamData(data);
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };

    if (examId) {
      fetchExamScheduleData();
    }
  }, [examId, authtoken]);

  console.log(getExamExamData, "getExamExamData1500")

  // ✅ Prepare dropdown date list
  const allDate =
    getExamExamData?.message?.examSchedule?.map((cls) => ({
      value: new Date(cls?.exam_date).toISOString().split("T")[0],
      label: new Date(cls?.exam_date).toISOString().split("T")[0],
    })) || [];

  // ✅ Filter exam list by selected date
  useEffect(() => {
    if (!getExamExamData?.message?.examSchedule) return;

    if (formData.exam_date) {
      const selectedExams = getExamExamData.message.examSchedule.filter(
        (exam) =>
          new Date(exam.exam_date).toISOString().split("T")[0] ===
          formData.exam_date
      );
      setFilteredExam(selectedExams || []);
    } else {
      setFilteredExam(getExamExamData?.message?.examSchedule || []);
    }
  }, [formData.exam_date, getExamExamData]);

  // ✅ Handle Submit (PUT API)
  const handleSubmit = async (BookexamId) => {
    setLoading(true);
    console.log("BookexamId:", BookexamId, "ExamId:", examId);

    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/exam-booking/reschedule-reexam/${bookingId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-auth": `${authtoken}`,
          },
          body: JSON.stringify({
            status: "reexamed",
            reexam_schedule_id: BookexamId,
            reg_id: Regi_id,
          }),
        }
      );

      if (response.ok) {
        Swal.fire("Success", "Re-Exam Booked Successfully", "success");
        navigate("/entranceresult");
      } else {
        const errorData = await response.json();
        Swal.fire("Error", errorData?.message || "Failed to book exam", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="page-wrapper">
      <Header />
      <div className="content background-color_row">
        <h3 className="text-center mb-4">Exam Re-Test</h3>
        <div className="row d-flex justify-content-center align-items-center background-color_row_2">
          <div className="col-md-5">
            <div className="card card_1">
              <form className="needs-validation" noValidate onSubmit={handleSubmit}>
                <label className="form-label">Select Date</label>
                <Select
                  className="Exam_date"
            value={formData.exam_date || ""}
            onChange={(e) =>
              setFormData({ ...formData, exam_date: e.target.value })
            }
                >
                     <option value="">Select Date</option>
            {allDate.map((item, i) => (
              <option key={i} value={item.value}>
                {item.label}
              </option>
            ))}
            </Select>
              </form>
            </div>
          </div>
        </div>


        {/* ✅ Exam Data List */}

        

        <div className="row mt-4">
        {filteredExam.length > 0 ? (
          filteredExam.map((exam, index) => (
            <div key={index} className="col-md-4 col-sm-6 mb-4">
                <div className="card h-100">
                  <div className="card-header card-buttons">
                    <h5 className="card-title">Exam Name: {exam.exam_name || "N/A"}</h5>
                    </div>
                    <div className="card-body Card_design_1">
              <p>
                <strong>Exam ID:</strong> <span>{exam.id}</span>
              </p>
              <p>
                      Exam Date: <span>{new Date(exam.exam_date).toISOString().split("T")[0]}</span>
                    </p>
              <p>
                <strong>Start Time:</strong> <span>{exam.start_time}</span>
              </p>
              <p>
                <strong>End Time:</strong> <span>{exam.end_time}</span>
              </p>
              <p>
                <strong>Available Seats:</strong><span>{exam.student_capacity}</span>
                
              </p>

              {/* <div className="text-center"> */}
                {loadingExamId === exam.id ? (
                  <button className="btn btn-primary mt-2" disabled>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Booking...
                  </button>
                ) : (
                  <button
                    className="btn btn-primary mt-2"
                    onClick={async () => {
                      setLoadingExamId(exam.id);
                      try {
                        await handleSubmit(exam.id);
                      } catch (err) {
                        console.error(err);
                      } finally {
                        setLoadingExamId(null);
                      }
                    }}
                    disabled={loadingExamId !== null}
                  >
                    Book Slot
                  </button>
                )}
              {/* </div> */}
              </div>
            </div>
            </div>
          ))
        ) : (
          <p className="text-center text-muted">
            No exams available for the selected date.
          </p>
        )}
</div>
      </div>
    </div>
  );
};

export default ExamReTest
